<template>
  <div :class="wrpClasses">
    <slot></slot>
  </div>
</template>

<script>
const prefixCls = 'bcc-breadcrumb'

export default {
  name: 'BccBreadcrumb',
  computed: {
    wrpClasses () {
      return `${prefixCls}`
    }
  },
  mounted () {
  }
}
</script>
